import axios, { AxiosError } from 'axios';
import { Api } from '../../axioscadastro';
import { v4 as uuidv4 } from 'uuid';

type NullableDate = Date | null | undefined;

export interface IListagemPedidoDireto {
  idpedido: string;
  emissao: Date;
  numero: string;
  nome: string;
  cpf: string; 
  valor: number;
}
export interface IitensPedidoDiretoDialog{
  iditens: string;   
  idprod: string;  
  descricao: string;
  un: string;
  ean: string;
  nome: string;
  codfabrica: string;
  quantidade: number;
  preco: number;      
  total: number;   
}   
interface IgetPedidoDireto {
  idcli: string;
  dataoperacao: Date;
  idfabrica: string;
  emissao: Date; 
  numero: string;
  valor: number;
  status: boolean;
  itens: IitensPedidoDiretoDialog[];
}
interface IDetalhePedidoDireto {
  idcli: string;
  dataoperacao: Date;
  emissao: Date; 
  idfabrica: string;
  numero: number;
  valor: number;
}
interface IItensImpressao{
 descricao: string;
 quantidade: number;
 un: string;
 preco: number;
 total: number;
 ean: string;
 nome: string;
}

interface IItensids{
  iditens: string;
}
interface Iitens{
  iditens: string;
  idprod: string; 
  descricao: string;
  un: string;
  ean: string;
  nome: string;
  codfabrica: string;
  quantidade: number;
  preco: number;
  total: number;
}
interface IFabricaImpressao{
  idfabrica: string;
	nome: string;
	logo: string;
  itens: IItensImpressao[];
}

interface ItensImpr {
 iditens: string;
 idpedido: string;
 idprod: string;
 codfabrica: string;
 descricao: string;
 un: string;
 ean: string;
 quantidade: number;
 preco: number;
 total: number;
};

export interface IgetImpressaoNota {
   dataoperacao: Date;
   valor: number;
   numero: string;
   nome: string;
   fantasia: string;
   endereco: string;
   bairro: string;
   cep: string;
   cpf: string;
   rg: string;
   celular: string;
   municipio: string;
   uf: string;
   logo: string;
   arquivo: string;
  itens: ItensImpr[];
}

type TotalCount = {
  data: IListagemPedidoDireto[];
  totalCount: number;
}
interface ErrorResponse {
  data: {
    errors: {
      [key: string]: string;
    };
  };
} 
interface ErrorResponsee {
  error: {
    default: string;
  };
}

const getAll = async (page = 1, tipo='', participante='', dataInicial = '', dataFinal='', ): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/pedidonota?page=${page}&limit=${17}&tipo=${tipo}&participante=${participante}&inicial=${dataInicial}&final=${dataFinal}`;
    const { data, headers } = await Api.get(urlRelativa);  
 
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 17),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const getById = async (id: string): Promise<IgetPedidoDireto | Error> => {
  try {

    const { data } = await Api.get(`/pedidonota/${id}`);

    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};
const getProdutos = async (
  tipo: string,
  idfabrica: string,
  idcli: string,
  id: string
): Promise<IitensPedidoDiretoDialog | Error> => {
  try {
    const { data } = await Api.get(
      `/produto?idcli=${idcli}&idfabrica=${idfabrica}&tipo=${tipo}&id=${id}`
    );
    if (data?.error?.default) {
      return new Error(data.error.default);
    }

    if (!data) {
      return new Error('Erro ao consultar o registro.');
    }

    return data;

  }catch (error) {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as any;

    const message =
      data?.error?.default ||
      data?.message ||
      data?.error ||
      'Erro interno no servidor';

    return new Error(message);
  }

  return new Error('Erro inesperado');
}
};

const create = async (dados: Omit<IDetalhePedidoDireto, 'numero'>, dadositens: IitensPedidoDiretoDialog[]): Promise<string | Error> => {
  try {  
    const guuid = uuidv4();
    const dadosExtraidos = dadositens.map(({ descricao, ean, un, codfabrica, nome, ...restoDoObjeto }) => ({idpedido: guuid, ...restoDoObjeto }));
    const dadosPedido = {idpedido: guuid, ...dados};
    const { data } = await Api.post<IDetalhePedidoDireto>('/pedidonota',  [dadosPedido, dadosExtraidos]); 
    if (Object.keys(data).length === 0) {  
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (typeof error === 'object' && error !== null && 'data' in error && 'errors' in (error as ErrorResponse).data) {
      const e = error as ErrorResponse;
      const errorMessages = Object.entries(e.data.errors)
        .map(([field, message]) => `${field}: ${message}`)
        .join('; ');
      return new Error(errorMessages);
    } else {
      return new Error('Erro ao Lançar Entrada');
    }
  }
};

const updateById = async (id: string, dados: Omit<IDetalhePedidoDireto, 'numero'>, dadositens: IitensPedidoDiretoDialog[], iddeletados: IItensids[]): Promise<void | Error> => {
  try {

    const dadosExtraidos = dadositens.map(({descricao, ean, un, codfabrica, nome, ...restoDoObjeto }) => ({idpedido: id, ...restoDoObjeto }));
    const { ...dadosIDetalheSaida } = dados;
    const dadosSaida = {idpedido: id, ...dadosIDetalheSaida};

    await Api.put(`/pedidonota/${id}`, [dadosSaida, dadosExtraidos, iddeletados]);

  }  catch (error) {
    if (typeof error === 'object' && error !== null && 'data' in error && 'errors' in (error as ErrorResponse).data) {
      const e = error as ErrorResponse;
      const errorMessages = Object.entries(e.data.errors)
        .map(([field, message]) => `${field}: ${message}`)
        .join('; ');
      return new Error(errorMessages);
    } else {
      return new Error('Erro ao Lançar Entrada');
    }
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/pedidonota/${id}`);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};

const Impressao = async (id: string): Promise<IgetImpressaoNota | Error> => {
  try {

    const { data } = await Api.get(`/pedidonotaimpressao/${id}`);

    if (data) { 
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

export const PedidoNotaService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
  getProdutos, 
  Impressao,
};